import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box component="footer" sx={{ mt: 'auto', p: 2, textAlign: 'center', bgcolor: 'background.paper', color: 'text.secondary', borderTop: '1px solid', borderColor: 'divider' }}>
      <Typography variant="body2">
        © EXNOA LLC / Studio KUMASAN Inc.
      </Typography>
      <Typography variant="body2">© teobject</Typography>
    </Box>
  );
}
